/*
 * Copyright (c) 2021 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Thursday, September 30th 2021, 1:25:07 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import * as React from "react";
import { Typography } from "@mui/material";
import { HorizontalStackWidget } from "ui-widgets";

interface PageTitleProps extends Pick<React.HTMLProps<HTMLDivElement>, "children"> {
  title?: React.ReactNode;
}

const PageTitle = ({ title = null, children }: PageTitleProps) => {
  return (
    <React.Fragment>
      <HorizontalStackWidget className="os-page-title">
        {title && <Typography variant="h5">{title}</Typography>}
        {children}
      </HorizontalStackWidget>
    </React.Fragment>
  );
};

export default PageTitle;
